import ConfigLine from './ConfigLine';
import './style/index.less';

export default ConfigLine;
